<template>
  <div class="section size-23_5">
    <div class="jrm-plan-wrp flex-c select-disabler">
      <div class="jrm-plan-header flex-c flex-algn-t size-100 ff-pdng-b-80">
        <div class="section size-100">
          <h2 class="jrm-plan-name">
            {{ editablePlan.title }}
          </h2>

          <!--<p class="jrm-plan-description">
            {{ editablePlan.description }}
          </p>-->
        </div>

        <div class="section size-100" style="margin-top:-40px;">
          <h2 class="jrm-plan-name txt-clr--jrm">
            {{ editablePlan.cost }} р.
          </h2>

          <p class="jrm-plan-description">
            {{ editablePlan.period }}
          </p>
        </div>

        <a :href="plan.href"
           class="button btn-about-plan flex-r size-100"
           target="_blank"
        >
          <div class="section size-90 text txt-algn-c">
            Подробнее о тарифе
          </div>
        </a>
      </div>

      <div class="jrm-plan-body flex-c size-100">
        <div class="section size-100">
          <div class="jrm-plan-futures">
            <div
              v-for="feature in editablePlan.features"
              :key="feature.title"
              class="jrm-plan--f-unit flex-r size-100"
            >
              <div class="section">
                <a
                  :href="feature.href"
                  target="_blank"
                >
                  {{ feature.title }}
                </a>
              </div>

              <div class="section txt-algn-r">
                {{ feature.additionalInformation }}

                <div class="help-mark" />
              </div>
            </div>
          </div>
        </div>

        <div class="section size-100">
          <template v-for="(customizationBlock, index) in editablePlan.customizationBlocks">
            <h3>
              {{ customizationBlock.title }}
            </h3>

            <div class="jrm-method-changer">
              <div
                v-for="ticket in customizationBlock.tickets"
                :key="ticket.title"
                class="jrm-m-c--unit-wrp size-100"
              >
                <div
                  class="jrm-m-c--unit"
                  :class="{ selected: ticket.isSelected, disabled: ticket.isDisabled }"
                  @click="selectTicketByCustomizationBlockAndTicket(index, ticket)"
                >
                  <div class="jrm-m-c--unit-name flex-r">
                    <div class="section size-70">
                      {{ ticket.title }}
                    </div>

                    <div class="section size-30 txt-algn-r txt-clr--jrm">
                      <template v-if="ticket.cost === 0">
                        Бесплатно
                      </template>

                      <template v-else>
                        +{{ ticket.cost }} р.
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div
            class="button primary btn-select-plan flex-r size-100"
            @click="selectPlan"
          >
            <div class="section size-60 text">
              Выбрать план
            </div>

            <div class="section size-40 txt-algn-r text txt-clr--jrm">
              {{ cost }} р.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep';

export default {
  name: 'PlanItem',
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editablePlan: cloneDeep(this.plan)
    };
  },
  computed: {
    cost() {
      const cost = this.editablePlan.cost + this.editablePlan.customizationBlocks.reduce((cost, block) => {
        return cost + block.tickets.find(({ isSelected }) => isSelected).cost;
      }, 0);

      return Math.round(cost * 100) / 100;
    }
  },
  methods: {
    selectPlan() {
      this.$emit('selectPlan', this.editablePlan);
    },
    selectTicketByCustomizationBlockAndTicket(customizationBlockIndex, ticket) {
      if (!ticket.isDisabled) {
        const customizationBlock = this.editablePlan.customizationBlocks[customizationBlockIndex];
        const selectedTicket = customizationBlock.tickets.find(({ isSelected }) => isSelected);

        if (selectedTicket !== undefined && selectedTicket !== ticket) {
          selectedTicket.isSelected = false;
          ticket.isSelected = true;
        }
      }
    }
  }
}
</script>
